import { API_PATHS } from '@/constants';
import { env } from '@/utils/env';

export function getContentApiImagesBaseUrl(): string {
  const baseUrl = env().apiBaseUrl.replace(/\/+$/, '');
  return `${baseUrl}${API_PATHS.CONTENT_IMAGES}`;
}

export function getContentApiImageUrl(blobName: string): string {
  return `${getContentApiImagesBaseUrl()}/${encodeURIComponent(blobName)}`;
}
